// Mehrphasenausbildung (MEP) partner portal.
// The KFV keeps one course category per MEP course type. Partner users pick the
// type when creating a course; the category itself is never editable by them.
export const MEP_COURSE_CATEGORY_MOT = 7
export const MEP_COURSE_CATEGORY_PKW = 15

export const MEP_COURSE_CATEGORY_IDS = [MEP_COURSE_CATEGORY_MOT, MEP_COURSE_CATEGORY_PKW]

// Durations carried over from the old FSZ Kursverwaltung.
export const MEP_COURSE_TYPES = [
  { categoryId: MEP_COURSE_CATEGORY_PKW, labelKey: 'pkw', durationMinutes: 100 },
  { categoryId: MEP_COURSE_CATEGORY_MOT, labelKey: 'mot', durationMinutes: 150 }
]

// Contact group that marks a contact as an MEP partner user (OEAMTC, ARBOE, ...).
export const MEP_CONTACT_GROUP_ID = 17

// Contact group holding the selectable course locations, same as the location
// filter on the trainer course lists.
export const MEP_LOCATION_CONTACT_GROUP_ID = 7

// Calendar event statuses the KFV keeps for the MEP workflow. "Angefordert" is
// the one a partner sets themselves when handing a course over to the KFV.
export const MEP_STATUS_NOT_ASSIGNED = 10
export const MEP_STATUS_ASSIGNED = 11
export const MEP_STATUS_REQUESTED = 12
export const MEP_STATUS_COMPLETED = 13

// The trainer portal's "suggested" filter wants no participants and
// min_participants > 1. MEP courses count participants nowhere, so this exists
// only to satisfy that filter and should not be read as a real figure.
export const MEP_MIN_PARTICIPANTS = 2

// Cancellation is the tenant's general "Abgesagt", not an MEP-specific status.
export const MEP_STATUS_CANCELLED = 2

// "Storno angefragt": a course with a trainer the partner asked the KFV to cancel.
// The KFV creates this status; the id must match the tenant setting
// mepCourseStatusCancellationRequested, or such courses drop out of the list.
export const MEP_STATUS_CANCELLATION_REQUESTED = 14

// Ampelfarben as the KFV defined them on 2026-09-15: yellow once a trainer is
// assigned but has not confirmed, green once they have, red while nobody is
// assigned - and red again when a course is close enough to start that an
// unconfirmed trainer has become a problem.
export const MEP_AMPEL_RED = '#dc2626'
export const MEP_AMPEL_YELLOW = '#d97706'
export const MEP_AMPEL_GREEN = '#16a34a'

export const MEP_UNCONFIRMED_WARNING_DAYS = 5

// A partner may change a course until this day of the month before it; the KFV
// plans the month from the list it receives the day after.
export const MEP_CHANGE_DEADLINE_DAY = 20

export const MEP_STATUS_IDS = [
  MEP_STATUS_NOT_ASSIGNED,
  MEP_STATUS_ASSIGNED,
  MEP_STATUS_REQUESTED,
  MEP_STATUS_COMPLETED,
  MEP_STATUS_CANCELLED,
  MEP_STATUS_CANCELLATION_REQUESTED
]

// Where the kilometres a trainer reports in the Routenplaner end up on each course's
// calendar event (the suite writes them, see TrainerKilometers there).
export const KM_CUSTOM_FIELD = 'f_1'

export const MEP_OVERVIEW_ROUTE = '/mep/courses'
